import React from 'react';
import styled from '@emotion/styled';
import { theme } from '../../styles/theme';

const StyledButton = styled.button`
  font-family: ${theme.typography.fontFamily};
  font-size: ${props => props.size === 'small' ? '0.875rem' : props.size === 'large' ? '1.125rem' : '1rem'};
  font-weight: ${theme.typography.button.fontWeight};
  text-transform: ${theme.typography.button.textTransform};
  padding: ${props => props.size === 'small' ? '6px 16px' : props.size === 'large' ? '12px 32px' : '8px 24px'};
  border-radius: ${theme.borderRadius.md};
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${theme.spacing.sm};
  
  ${props => {
    switch (props.variant) {
      case 'outlined':
        return `
          background: transparent;
          border: 2px solid ${theme.colors[props.color || 'primary']};
          color: ${theme.colors[props.color || 'primary']};
          &:hover {
            background: ${theme.colors[props.color || 'primary']}10;
          }
        `;
      case 'text':
        return `
          background: transparent;
          color: ${theme.colors[props.color || 'primary']};
          &:hover {
            background: ${theme.colors[props.color || 'primary']}10;
          }
        `;
      default:
        return `
          background: ${theme.colors[props.color || 'primary']};
          color: white;
          box-shadow: ${theme.shadows.sm};
          &:hover {
            box-shadow: ${theme.shadows.md};
            transform: translateY(-1px);
          }
        `;
    }
  }}

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    &:hover {
      transform: none;
      box-shadow: none;
    }
  }
`;

const Button = ({
  children,
  variant = 'contained',
  color = 'primary',
  size = 'medium',
  startIcon,
  endIcon,
  ...props
}) => {
  return (
    <StyledButton
      variant={variant}
      color={color}
      size={size}
      {...props}
    >
      {startIcon && startIcon}
      {children}
      {endIcon && endIcon}
    </StyledButton>
  );
};

export default Button; 